<template>
    <section class="panel-body">
        <filter-control @params="getFiles" ref="FilterControl" :model="model" :query="query">
            <span slot="custom">
                <span class="w-100 text-center">
                    &nbsp;<button :disabled="!user.fk_empresa_id || !allow('UPLOAD')" class="btn btn-sm btn-success"
                        @click="prepareFolderOperation('STORE')"><i class="fa fa-plus"></i> Criar Pasta</button>&nbsp;
                    <!--     &nbsp;<button :disabled="!selectedFiles.length || !everyAllowedSign"
                        class="btn btn-sm btn-default"><i class="fa fa-share"></i>
                        Enviar Assinatura</button>&nbsp; -->
                    &nbsp;<button @click="baixarLote" :disabled="!selectedFiles.length"
                        class="btn btn-sm btn-default"><i class="fa fa-cloud-download"></i> Baixar</button>&nbsp;
                    &nbsp;<button @click="baixarLogLote" :disabled="!selectedFiles.length"
                        class="btn btn-sm btn-default"><i class="fa fa-download"></i>
                        Baixar com Log</button>&nbsp;
                    &nbsp;<button @click="moverLote" :disabled="!selectedFiles.length" class="btn btn-sm btn-default"><i
                            class="fa fa-cut"></i>
                        Mover</button>&nbsp;
                    <!--   <button :disabled="!selectedFiles.length || !everyAllowedDelete" @click="deleteMany"
                        class="btn btn-danger btn-sm" :class="appLayout.btn" data-target="#uploadModal"
                        data-toggle="modal" href="#"><i class="fa fa-trash"></i>
                        Excluir</button> -->
                </span>
            </span>
        </filter-control>
        <p class="text-sm p-0">{{user.pathAtual}}</p>
        <button v-if="user.nivel" @click="backFolder()" :disabled="user.nivel.fk_nivel_id == user.folders.id"
            class="btn btn-sm btn-outline-secondary"><i class="fa fa-reply"></i> Voltar</button>&nbsp;
        <button :disabled="user.nivel.fk_nivel_id == user.folders.id" @click="changeToRoot()"
            class="btn btn-sm btn-outline-secondary">
            <i class="nav-icon fa fa-home"></i>
            Inicio
        </button>
        <button @click="displayTable = !displayTable" class="float-right btn btn-sm btn-outline-secondary">
            <i class="nav-icon fa" :class="{'fa-table': displayTable, 'fa-list': !displayTable}"></i>
        </button>
        <div class="row">
            <div class="col-md-12">
                <div class="container-fluid">
                    <p class="text-sm">Pastas</p>
                </div>
                <template v-for="(item, i) in currentFolder">
                    <folder-section :key="i" @dblclick.native="openFolder(item)" @click.native="selectFolder(item)"
                        @clickOpen="openFolderMenu" @contextmenu.native.prevent="$refs.menuFolder.open($event, item)"
                        :folder="item">
                    </folder-section>
                </template>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="container-fluid">
                    <p class="text-sm">Arquivos</p>
                </div>
            </div>
            <div class="col-md-12" v-if="!displayTable">
                <template v-for="(item, i) in files">
                    <file-section @clickOpen="openFileMenu" @showSignatures="showSignatures" @selectFile="selectFile"
                        @contextmenu.native.prevent="openFileMenu($event, item)" :file="item" :key="i">
                    </file-section>
                </template>
            </div>
            <div class="col-md-12" v-else>
                <file-table @clickOpen="openFileMenu" @selectFile="selectFile" :files="files"></file-table>
            </div>
        </div>
        <infinite-loading :identifier="loadingId" :distance="5" :forceUseInfiniteWrapper="true" spinner="waveDots"
            @infinite="infiniteHandler">
            <div slot="spinner">Carregando...</div>
            <div slot="no-more">Sem mais arquivos</div>
            <div slot="no-results">Sem mais arquivos</div>
        </infinite-loading>
        <vue-context ref="menuFolder" @close="onCloseFolder" :close-on-click="true" @open="onOpenFolder"
            v-slot="{data}">
            <li>
                <a href="#" @click.prevent="openFolder(data)"><i class="fa fa-folder-open"></i>
                    Abrir
                    Pasta</a>
            </li>
            <li>
                <a href="#" @click.prevent="prepareFolderOperation('UPDATE')"><i class="fa fa-pencil"></i> Renomear
                    Pasta</a>
            </li>
            <li>
                <a href="#" @click.prevent="prepareFolderOperation('DELETE')"><i class="fa fa-trash"></i> Remover
                    Pasta</a>
            </li>
            <li>
                <a href="#" @click.prevent="pastaPropriedades(data)"><i class="fa fa-file-text-o"></i> Propriedades</a>
            </li>
        </vue-context>

        <vue-context ref="menuFile" :close-on-click="true" @open="onOpenFile" @close="onCloseFile" v-slot="{data}">
            <li><a href="#" @click.prevent="showFile(data.id)"><i class="fa fa-eye"></i> Detalhes</a></li>
            <li v-if="showShare(data)"><a href="#" @click.prevent="envioEmail(data)"><i class="fa fa-share"></i> Enviar
                    para Assinaturas</a></li>
            <li v-if="showShare(data)"><a href="#" @click.prevent="autoAssinar(data)"><i
                        class="fa fa-check-circle-o"></i> Auto Assinar</a></li>
            <li v-if="showSign(data)" class="d-none d-md-block v-context__sub">
                <a><i class="fa fa-paint-brush"></i> Assinar</a>
                <ul class="v-context">
                    <li><a href="#" @click.prevent="signWithoutCertificate(data)"><i class="fa fa-pencil"></i>
                            Assinar</a></li>
                    <li><a href="#" @click.prevent="signWithCertificate(data)"><i class="fa fa-gavel"></i>
                            Assinar com Certificado</a></li>
                    <li><a href="#" @click.prevent="denyFile(data)"><i class="fa fa-thumbs-down"></i>
                            Recusar Documento</a></li>
                </ul>
            </li>
            <li class="d-md-none" v-if="showSign(data)"><a href="#" @click.prevent="signWithoutCertificate(data)"><i
                        class="fa fa-pencil"></i> Assinar</a></li>
            <li class="d-md-none" v-if="showSign(data)"><a href="#" @click.prevent="signWithCertificate(data)"><i
                        class="fa fa-gavel"></i>
                    Assinar com Certificado</a></li>
            <li class="d-md-none" v-if="showSign(data)"><a href="#" @click.prevent="denyFile(data)"><i
                        class="fa fa-thumbs-down"></i>
                    Recusar Documento</a></li>
            <li>
                <a href="#" @click.prevent="copyLink(data)"><i class="fa fa-chain"></i> Copiar link público</a>
            </li>
            <li class="v-context__sub">
                <a><i class="fa fa-download"></i> Baixar</a>
                <ul class="v-context">
                    <li><a href="#" @click.prevent="downloadFile(data)"><i class="fa fa-cloud-download"></i> Baixar </a>
                    </li>
                    <li><a href="#" @click.prevent="downloadFileWithLog(data)"><i class="fa fa-file-text-o"></i> Baixar
                            com
                            Log
                        </a></li>
                </ul>
            </li>
            <li class="v-context__sub">
                <a><i class="fa fa-ellipsis-h"></i> Mais opções</a>
                <ul class="v-context">
                    <li>
                        <a href="#" @click.prevent="moveFile(data)"><i class="fa fa-cut"></i> Mover
                            Arquivo</a>
                    </li>
                    <li>
                        <a v-if="showShare(data)" href="#" @click.prevent="renameFile(data)"><i class="fa fa-edit"></i>
                            Renomear Arquivo</a>
                    </li>
                    <li v-if="showDelete(data)"><a href="#" @click.prevent="deleteFile(data)"><i
                                class="fa fa-trash"></i> Remover</a></li>
                    <li v-if="showDelete(data) && ((data) && !data.expired_at)"><a href="#" class="text-red"
                            @click.prevent="cancelFile(data)"><i class="fa fa-times-circle-o"></i>
                            Cancelar Documento</a></li>
                </ul>
            </li>

        </vue-context>
        <m-file ref="ModalFile"></m-file>
        <m-envio-assinatura ref="ModalEnvioAssinatura" @refreshFiles="fetchFiles"></m-envio-assinatura>
        <m-certificate v-if="signatureCertificate" ref="ModalCertificate" @refreshFiles="fetchFiles"></m-certificate>
        <m-assinar ref="ModalAssinar" @refreshFiles="fetchFiles"></m-assinar>
        <m-move-file ref="ModalMoveFile" @prepareFolderRequest="prepareFolderRequest" @refreshFiles="fetchFiles">
        </m-move-file>
        <m-folder ref="mFolder" @updateData="updateLevels"></m-folder>
        <m-folder-propries ref="mFolderPropries"></m-folder-propries>
        <m-rename-file ref="ModalRenameFile" @refreshFiles="fetchFiles"></m-rename-file>
        <m-show-signatures ref="ModalShowSignatures"></m-show-signatures>
        <m-recusa ref="ModalRecusa"></m-recusa>
        <m-auto-assinar ref="ModalAutoAssinar"></m-auto-assinar>
    </section>
</template>

<script>
    import FilterControl from '../../components/advanced-filter/FilterControl';
    import FolderSection from './components/folder-section';
    import FileSection from './components/file-section';
    import mFolder from '../niveis/components/m-folder';
    import mFolderPropries from '../niveis/components/m-folder-propries';
    import mCertificate from '../../components/file-signature/m-certificate';
    import mAssinar from '../../components/file-signature/m-assinar.vue';
    import mFile from '../../components/file-manipulation/m-file-details';
    import mEnvioAssinatura from '../../components/file-manipulation/m-compartilhar';
    import fileOperations from './functions/fileOperations';
    import mMoveFile from '../../components/file-manipulation/m-move-file.vue';
    import MRenameFile from '../../components/file-manipulation/m-rename-file.vue';
    import MShowSignatures from '../../components/file-manipulation/m-show-signatures.vue';
    import MRecusa from '../../components/file-signature/m-recusa.vue';
    import fileTable from './components/file-table.vue';
    import MAutoAssinar from '../../components/file-signature/m-auto-assinar.vue';
    export default {
        components: {
            fileTable,
            FilterControl,
            FolderSection,
            FileSection,
            mFolder,
            mFolderPropries,
            mFile,
            mEnvioAssinatura,
            mCertificate,
            mAssinar,
            mMoveFile,
            MRenameFile,
            MShowSignatures,
            MRecusa,
            MAutoAssinar
        },
        data() {
            return {
                signatureCertificate: false,
                displayTable: false,
                params: {},
                loadingId: null,
                everyAllowedDelete: false,
                everyAllowedSign: false,
                contextMenuIsVisible: false,
                top: 0,
                left: 0,
                selectedFolder: {},
                selectedFile: {},
                selectedFiles: [],
                model: 'arquivo',
                infiniteAction: 'ADD_ARQUIVOS',
                storeAction: 'SET_ARQUIVOS',
                url: '/api/arquivos',
                query: {
                    order_column: 'created_at',
                    order_direction: 'desc',
                    filter_match: 'and',
                    limit: 5,
                    page: 1
                }
            }
        },
        computed: {
            refreshId() {
                return this.$store.state.user.refresh_id;
            },
            user() {
                return this.$store.state.user.data;
            },
            currentFolder() {
                return this.$store.state.user.data.currentFolder
            },
            folders() {
                return this.$store.state.user.data.folders;
            },
            files() {
                return this.$store.state.arquivo.data;
            },
        },
        beforeMount() {
            this.createUUID = this.createUUID.bind(this);
            this.showFile = fileOperations.showFile.bind(this);
            this.downloadFile = fileOperations.downloadFile.bind(this);
            this.downloadFileWithLog = fileOperations.downloadFileWithLog.bind(this);
            this.fetchFiles = fileOperations.fetchFiles.bind(this);
            this.getFiles = fileOperations.getFiles.bind(this);
            this.renameFile = fileOperations.renameFile.bind(this);
            this.moveFile = fileOperations.moveFile.bind(this);
            this.copyLink = fileOperations.copyLink.bind(this);
            this.selectFolder = fileOperations.selectFolder.bind(this);
            this.onOpenFolder = fileOperations.onOpenFolder.bind(this);
            this.onCloseFolder = fileOperations.onCloseFolder.bind(this);
            this.onOpenFile = fileOperations.onOpenFile.bind(this);
            this.onCloseFile = fileOperations.onCloseFile.bind(this);
            this.prepareFolderOperation = fileOperations.prepareFolderOperation.bind(this);
            this.openFolder = fileOperations.openFolder.bind(this);
            this.backFolder = fileOperations.backFolder.bind(this);
            this.deleteFile = fileOperations.deleteFile.bind(this);
            this.cancelFile = fileOperations.cancelFile.bind(this);
            this.denyFile = fileOperations.denyFile.bind(this);
            this.envioEmail = fileOperations.envioEmail.bind(this);
            this.autoAssinar = fileOperations.autoAssinar.bind(this);
            this.signWithCertificate = fileOperations.signWithCertificate.bind(this);
            this.signWithoutCertificate = fileOperations.signWithoutCertificate.bind(this);
            this.infiniteHandler = fileOperations.infiniteHandler.bind(this);
            this.showSign = fileOperations.showSign.bind(this);
            this.showDelete = fileOperations.showDelete.bind(this);
            this.showShare = fileOperations.showShare.bind(this);
            this.openFileMenu = fileOperations.openFileMenu.bind(this);
            this.showSignatures = fileOperations.showSignatures.bind(this);
            this.openFolderMenu = fileOperations.openFolderMenu.bind(this);
            this.baixarLote = fileOperations.baixarLote.bind(this);
            this.baixarLogLote = fileOperations.baixarLogLote.bind(this);
            this.moverLote = fileOperations.moverLote.bind(this);
            this.loadingId = this.createUUID();
        },
        watch: {
            $route(data) {
                if (data.name === 'cofre' && this.user.ambiente == 'S') {
                    this.$router.push('/inbox');
                    return;
                }
                if (data.name == '451') {
                    this.$destroy();
                    return
                }

                if (data.name === 'cofre') {
                    this.fetchFiles(1);
                }
            },
            'user.ambiente'(data) {
                if (data == 'S') {
                    this.$router.push('/inbox');
                }
            },
            'user.pathAtual'(data) {
                this.fetchFiles(1);
            },
            'refreshId'(data) {
                this.fetchFiles(1);
            }
        },
        methods: {
            changeToRoot() {
                this.$store.dispatch('goToRoot').then(r => {
                    this.fetchFiles(1);
                });
            },
            pastaPropriedades(payload) {
                this.$refs.mFolderPropries.show(payload);
            },
            checkLotButtons() {
                this.everyAllowedDelete = true;
                this.everyAllowedSign = true;
                this.selectedFiles.map(item => {
                    if (!this.showDelete(item)) {
                        this.everyAllowedDelete = false;
                    }
                    if (!this.showShare(item)) {
                        this.everyAllowedSign = false;
                    }
                });
            },
            selectFile(payload) {
                let id = this.selectedFiles.findIndex(x => x.id == payload.id);
                if (id == -1) {
                    this.selectedFiles.push(payload);
                } else {
                    this.selectedFiles = this.selectedFiles.filter(x => x.id != payload.id);
                }
                this.checkLotButtons();
            },
            deleteMany() {
                let ids = this.files.filter(i => i.selected);
            },
            prepareFolderRequest(payload) {
                if (payload.operation === 'DELETE') {
                    this.$refs.mFolder.folder = _.cloneDeep(payload.folder);
                    this.$refs.mFolder.destroyLevel();
                    return
                }
                this.$refs.mFolder.folder = _.cloneDeep(payload.folder);
                if (payload.operation == 'STORE') {
                    this.$refs.mFolder.folder.title = null;
                }
                this.$refs.mFolder.folder.children = payload.folder.children;
                this.$refs.mFolder.folder.operation = payload.operation;
                setTimeout(function () {
                    $('#Nome').focus();
                }, 500);
                $('#ModalEditarNivel').modal('toggle');
            },
            updateLevels(payload) {
                this.$refs.ModalMoveFile.updateLevels();
            },

        }
    }
</script>